import React, { Component } from "react";
import EnsResolver from 'ens-resolver';

const CONTRACT = '0xA8A6CB3978e2c4EdcF5A3d0cB3400E1E5D031479';
const MUTED = '#AAAAAA';

/**
 * Ownership line shown beneath an edition.
 *
 * Identical markup previously lived in P5Cell, ThreeCell and IPFSImageCell.
 *
 * `asOf` is set when the owner came from the archive snapshot rather than from
 * chain. Ownership is the one cached value that can go wrong silently — a
 * transfer invalidates it the moment it happens — so a cached owner is always
 * captioned with the date it was read. Without that, a months-old owner would
 * read exactly like a live one.
 */
class OwnerCaption extends Component {
  formatAsOf(iso) {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  render() {
    const { tokenId, owner, asOf } = this.props;
    const url = `https://etherscan.io/nft/${CONTRACT}/${tokenId}`;

    if (!owner) {
      return (
        <>
          Provenance &amp; ownership on&nbsp;
          <a href={url} target="_new" style={{ color: MUTED }}>Etherscan</a>
        </>
      );
    }

    const asOfDate = asOf ? this.formatAsOf(asOf) : null;

    return (
      <>
        From the collection of&nbsp;
        <a href={url} target="_new" style={{ color: MUTED }}>
          {asOfDate ? `${owner.slice(0, 6)}...${owner.slice(-4)}` : <EnsResolver lookup={owner} />}
        </a>
        {' '}
        {!asOfDate && <a href={url} target="_new" style={{ color: MUTED, fontSize: '0.8em' }}>
          ({owner.slice(0, 6)}...{owner.slice(-4)})
        </a>}
        {asOfDate && (
          <span
            style={{ color: MUTED, fontSize: '0.8em' }}
            title="Ownership read from a saved snapshot, not live from chain. Follow the link for current ownership."
          >
            {' '}as of {asOfDate}
          </span>
        )}
      </>
    );
  }
}

export default OwnerCaption;
